'use strict';
import { get_ms_timestamp, ms_to_s, get_timestamp, generate_uuid, get_page_path, get_server_time, getUniqueId, } from './utils';
import { get_device } from './device';
import { store } from './store';
import { send } from './send';
import { logger } from './logger';
var Application = (function () {
    function Application() {
        var _this = this;
        this.zip = {
            meta: 'm',
            id: 'i',
            device_type: 'd',
            product_code: 'p',
            ext: 'e',
            'finger-print': 'fp',
            body: 'b',
            timestamp: 't',
            event_id: 'e',
            biz_data: 'd',
            is_dev: 'tst',
            heatmap: 'h',
        };
        this.queue_size = 1000;
        this.consents = {
            event: false,
            view: false,
            user: false,
            app: false,
            device: false,
        };
        this.internals = {
            send: Object.assign(send),
            store: Object.assign(store),
            logger: Object.assign(logger),
        };
        this._features = Object.keys(this.consents);
        this.product_code = '';
        this.debug = false;
        this.interval = 500;
        this.url = '';
        this.features = this._features;
        this.time_server_url = window.location.href;
        this.domain = '.codemao.cn';
        this.is_dev = false;
        this.heatmap = false;
        this.default_time_offset = 0;
        this.user_server_time = 0;
        this.timed_events = {};
        this.inited = false;
        this.has_pulse = false;
        this.app_end = false;
        this.last_view = get_page_path();
        this.set_page_view_record_path = this.last_view;
        this.data_queque = [];
        this.data_queque_limit = 1000;
        this.event_data_limit = 5 * 1000;
        this.report_data_limit = 30 * 1000;
        this.user_detail = {};
        this.other_ext = {};
        this.user_device = {};
        this.get_servetime = false;
        this.temporary_queue = [];
        this.handle_heatmap_report = function (event, type, fn) {
            var element = event.target;
            var selector = getUniqueId(element);
            var report_data = {
                name: element.getAttribute('data-buried') || '未命名元素',
                page: location.host + location.pathname,
                selector: selector.wid,
            };
            Object.assign(report_data, fn(event, report_data));
            _this.add_event({
                key: "heatmap_" + type,
                segmentation: report_data,
            });
        };
        this.init = this.init.bind(this);
        this.destory = this.destory.bind(this);
        this.turn_on = this.turn_on.bind(this);
        this.turn_off = this.turn_off.bind(this);
        this.clean = this.clean.bind(this);
        this.add_feature = this.add_feature.bind(this);
        this.remove_feature = this.remove_feature.bind(this);
        this.check_feature = this.check_feature.bind(this);
        this.set_feature = this.set_feature.bind(this);
        this.set_page_view = this.set_page_view.bind(this);
        this.get_user_detail = this.get_user_detail.bind(this);
        this.ext = this.ext.bind(this);
        this.start_event = this.start_event.bind(this);
        this.pause_event = this.pause_event.bind(this);
        this.stop_event = this.stop_event.bind(this);
        this.end_event = this.end_event.bind(this);
        this.start_session = this.start_session.bind(this);
        this.end_session = this.end_session.bind(this);
        this.report_page_visit = this.report_page_visit.bind(this);
        this.report_view_duration = this.report_view_duration.bind(this);
        this.report_app_duration = this.report_app_duration.bind(this);
        this.visibility_listener = this.visibility_listener.bind(this);
        this.report_device = this.report_device.bind(this);
        this.heart_beat = this.heart_beat.bind(this);
        this.add_cmao_events = this.add_cmao_events.bind(this);
        this.send_report = this.send_report.bind(this);
        this.getDataSize = this.getDataSize.bind(this);
        this.getRequestData = this.getRequestData.bind(this);
    }
    Application.prototype.init = function (_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, interval = _b.interval, debug = _b.debug, url = _b.url, features = _b.features, time_server_url = _b.time_server_url, domain = _b.domain, product_code = _b.product_code, is_dev = _b.is_dev, heatmap = _b.heatmap, server_time = _b.server_time;
        if (this.inited) {
            return this;
        }
        this.interval = interval || this.interval;
        this.debug = debug || this.debug;
        this.is_dev = is_dev || this.is_dev;
        this.product_code = product_code || this.product_code;
        this.features = features || this.features;
        this.time_server_url = time_server_url || this.time_server_url;
        this.domain = domain || this.domain;
        this.url = this.is_dev ? (url || (this.url && this.url.replace(/\/$/, ''))) + "_dev" : (url || (this.url && this.url.replace(/\/$/, '')));
        this.heatmap = heatmap || this.heatmap;
        this.user_server_time = server_time || 0;
        if (!this.product_code) {
            logger.error('Please set product code');
            return this.turn_off();
        }
        if (!this.url) {
            logger.error('Please set url');
            return this.turn_off();
        }
        this.has_pulse = true;
        this.add_feature(this.features);
        if (server_time != null) {
            this.default_time_offset = +server_time - new Date().getTime();
            this.heart_beat();
        }
        else {
            get_server_time(this.time_server_url).then(function () {
                _this.get_servetime = true;
                if (_this.temporary_queue.length > 0) {
                    _this.temporary_queue.forEach(function (event) {
                        event.timestamp = get_timestamp(_this.default_time_offset);
                        _this.data_queque.push(event);
                    });
                }
                _this.heart_beat();
            }, function () {
                _this.get_servetime = true;
                if (_this.temporary_queue.length > 0) {
                    _this.temporary_queue.forEach(function (event) {
                        _this.data_queque.push(event);
                    });
                }
                _this.heart_beat();
            });
        }
        this.report_device();
        this.start_session();
        if (this.heatmap) {
            this.heatmap_listener('click');
        }
        this.inited = true;
        return this;
    };
    Application.prototype.destory = function () {
        this.turn_off();
        this.inited = false;
        this.app_end = false;
        if (window && window.addEventListener) {
            window.removeEventListener('beforeunload', this.end_session);
            window.removeEventListener('unload', this.end_session);
        }
        return this;
    };
    Application.prototype.turn_on = function () {
        if (!this.has_pulse) {
            this.has_pulse = true;
            this.heart_beat();
        }
        return this;
    };
    Application.prototype.turn_off = function () {
        this.has_pulse = false;
        return this;
    };
    Application.prototype.clean = function () {
        this.data_queque = [];
        return this;
    };
    Application.prototype.add_feature = function (feature) {
        return this.set_feature(feature, true);
    };
    Application.prototype.remove_feature = function (feature) {
        return this.set_feature(feature, false);
    };
    Application.prototype.check_feature = function (feature) {
        if (this.consents[feature]) {
            return this.consents[feature];
        }
        else {
            logger.warn("No feature available for " + feature);
        }
        return false;
    };
    Application.prototype.set_feature = function (feature, flag) {
        logger((flag ? 'Adding' : 'Remove') + " consent for " + feature);
        if (feature.constructor === Array) {
            for (var i = 0; i < feature.length; i++) {
                this.set_feature(feature[i], flag);
            }
        }
        else if (this.consents[feature] !== undefined) {
            this.consents[feature] = flag;
        }
        else {
            logger.warn("No feature available for " + feature);
        }
        return this;
    };
    Application.prototype.set_page_view = function (path) {
        if (this.check_feature('view')) {
            this.report_page_visit(path);
            this.report_view_duration();
            this.start_event('EVENT_SESSION');
            this.last_view = path;
            this.set_page_view_record_path = path;
        }
        return this;
    };
    Application.prototype.get_user_detail = function (user) {
        if (this.check_feature('user')) {
            logger('Adding userdetails: ', user);
            this.user_detail = user;
            this.add_cmao_events({
                key: 'EVENT_SIGN',
                segmentation: user,
            });
        }
        return this;
    };
    Application.prototype.ext = function (data) {
        this.other_ext = Object.assign({}, this.other_ext, data);
        return this;
    };
    Application.prototype.add_event = function (event) {
        if (this.check_feature('event')) {
            if (event.constructor === Array) {
                this.add_event(event);
            }
            else {
                if (typeof event === 'string') {
                    event = {
                        key: event,
                    };
                }
                this.add_cmao_events(event);
            }
        }
        return this;
    };
    Application.prototype.start_event = function (key) {
        if (this.check_feature('event')) {
            var timed_event = this.timed_events[key];
            if (timed_event) {
                if (timed_event.stop_time) {
                    timed_event.start_time += get_ms_timestamp(this.default_time_offset) - timed_event.stop_time;
                    timed_event.stop_time = null;
                }
                else {
                    logger.warn("Timed event with key " + key + " was started");
                }
            }
            else {
                this.timed_events[key] = {
                    start_time: get_ms_timestamp(this.default_time_offset),
                    stop_time: null,
                };
            }
        }
        return this;
    };
    Application.prototype.pause_event = function (key) {
        if (this.check_feature('event')) {
            var timed_event = this.timed_events[key];
            if (!timed_event) {
                logger.warn("Timed event with key " + key + " not found");
            }
            else {
                if (timed_event.stop_time) {
                    logger.warn("Timed event with key " + key + " was paused");
                }
                else {
                    timed_event.stop_time = get_ms_timestamp(this.default_time_offset);
                }
            }
        }
        return this;
    };
    Application.prototype.stop_event = function (key) {
        if (this.check_feature('event')) {
            var timed_event = this.timed_events[key];
            if (!timed_event) {
                logger.warn("Timed event with key " + key + " not found");
            }
            else {
                delete this.timed_events[key];
            }
        }
        return this;
    };
    Application.prototype.end_event = function (event) {
        if (this.check_feature('event')) {
            if (typeof event === 'string') {
                event = { key: event };
            }
            if (!event.key) {
                logger.error('Event must have key property');
                return this;
            }
            if (!this.timed_events[event.key]) {
                logger.warn("Timed event with key " + event.key + " was not started");
                return this;
            }
            var _a = this.timed_events[event.key], stop_time = _a.stop_time, start_time = _a.start_time;
            event.dur = stop_time
                ? stop_time - start_time
                : get_ms_timestamp(this.default_time_offset) - start_time;
            this.add_cmao_events(event);
            delete this.timed_events[event.key];
        }
        return this;
    };
    Application.prototype.start_session = function () {
        this.report_page_visit(this.last_view);
        if (this.check_feature('app')) {
            this.start_event('EVENT_EXIT');
        }
        if (this.check_feature('view')) {
            this.start_event('EVENT_SESSION');
        }
        this.visibility_listener();
        if (window && window.addEventListener) {
            window.addEventListener('beforeunload', this.end_session);
            window.addEventListener('unload', this.end_session);
        }
    };
    Application.prototype.end_session = function () {
        if (!this.app_end) {
            if (this.check_feature('app')) {
                this.report_app_duration();
            }
            if (this.check_feature('view')) {
                var curr_view = get_page_path();
                if (curr_view === this.last_view && curr_view === this.set_page_view_record_path) {
                    this.report_view_duration();
                }
            }
            this.heart_beat({ end: true });
            this.app_end = true;
        }
        return this;
    };
    Application.prototype.report_page_visit = function (path) {
        if (path) {
            this.add_cmao_events({
                key: 'EVENT_PAGE',
                segmentation: {
                    path: path,
                    domain: window && window.location ? window.location.hostname : '',
                },
            });
        }
    };
    Application.prototype.report_view_duration = function () {
        if (this.last_view) {
            this.end_event({
                key: 'EVENT_SESSION',
                segmentation: {
                    path: this.last_view,
                },
            });
        }
    };
    Application.prototype.report_app_duration = function () {
        this.end_event('EVENT_EXIT');
    };
    Application.prototype.visibility_listener = function () {
        var _this = this;
        if (window && window.addEventListener) {
            if (document && document.hidden !== void 0) {
                document.addEventListener('visibilitychange', function (e) {
                    if (_this.check_feature('app')) {
                        _this[document.hidden ? 'pause_event' : 'start_event']('EVENT_EXIT');
                    }
                    if (_this.check_feature('view')) {
                        _this[document.hidden ? 'pause_event' : 'start_event']('EVENT_SESSION');
                    }
                });
            }
        }
    };
    Application.prototype.beforeHeatmapReport = function (event, data) {
        return {};
    };
    Application.prototype.heatmap_listener = function (type) {
        var _this = this;
        if (window && window.addEventListener) {
            if (document && document.hidden !== void 0) {
                document.addEventListener(type, function (event) { return _this.handle_heatmap_report(event, type, _this.beforeHeatmapReport); }, true);
            }
        }
    };
    Application.prototype.report_device = function () {
        if (this.check_feature('device')) {
            this.user_device = get_device(this.domain);
        }
    };
    Application.prototype.heart_beat = function (_a) {
        var _this = this;
        var _b = _a === void 0 ? {} : _a, _c = _b.immediate, immediate = _c === void 0 ? true : _c, _d = _b.end, end = _d === void 0 ? false : _d;
        if (!this.has_pulse) {
            return false;
        }
        if (!immediate) {
            return setTimeout(this.heart_beat, this.interval);
        }
        if (this.data_queque.length > 0) {
            var requestDatas_1 = this.getRequestData(end);
            requestDatas_1.forEach(function (requestData, index) {
                var isLastReport = end && index === requestDatas_1.length - 1;
                _this.send_report(requestData, isLastReport);
            });
        }
        setTimeout(this.heart_beat, this.interval);
    };
    Application.prototype.getRequestData = function (isLastHeartBeat) {
        if (isLastHeartBeat === void 0) { isLastHeartBeat = false; }
        var requestDatas = [];
        do {
            var cmaoEvents = [];
            var cmaoEventsSize = 0;
            for (var _i = 0, _a = this.data_queque; _i < _a.length; _i++) {
                var eventData = _a[_i];
                cmaoEventsSize += eventData.dataSize || 0;
                if (cmaoEventsSize > this.report_data_limit) {
                    break;
                }
                delete eventData.dataSize;
                cmaoEvents.push(eventData);
            }
            this.data_queque = this.data_queque.filter(function (item) { return item.dataSize; });
            window.REPORT_LOG && console.log('data_queque length', this.data_queque.length);
            var request = {
                meta: {
                    device_type: 1,
                    product_code: this.product_code,
                    is_dev: this.is_dev,
                    heatmap: this.heatmap,
                },
                ext: {},
                body: cmaoEvents,
            };
            if (this.user_device) {
                Object.assign(request.ext, this.user_device);
            }
            if (this.other_ext) {
                Object.assign(request.ext, this.other_ext);
            }
            if (this.user_detail) {
                Object.assign(request.ext, this.user_detail);
            }
            var compress_request = this.compress(request, this.zip);
            requestDatas.push(compress_request);
        } while (isLastHeartBeat && this.data_queque.length > 0);
        return requestDatas;
    };
    Application.prototype.send_report = function (requestData, end) {
        if (end === void 0) { end = false; }
        logger('Processing request', requestData);
        send(requestData, { end: end }, this.url, this.debug, function (err) {
            logger('Request Finished', requestData);
            if (err) {
                window.REPORT_LOG && console.error('event data report faild', err);
            }
        });
    };
    Application.prototype.add_cmao_events = function (event) {
        if (!event.key) {
            logger.error('Event must have key property');
            return;
        }
        var key = event.key, dur = event.dur, _a = event.segmentation, segmentation = _a === void 0 ? {} : _a;
        var e = {};
        e.timestamp = get_timestamp(this.default_time_offset);
        e.id = generate_uuid();
        e.event_id = key;
        e.biz_data = segmentation;
        if (dur) {
            e.biz_data._dur = ms_to_s(dur);
        }
        var eventDataSize = this.getDataSize(e, 3);
        if (eventDataSize > this.event_data_limit) {
            window.REPORT_LOG && console.error("report event: " + key + "\uFF0C data size over limit\uFF0Cevent ata size: " + eventDataSize + "\uFF0Climit size: " + this.event_data_limit);
            return;
        }
        if (this.data_queque.length >= this.data_queque_limit) {
            window.REPORT_LOG && console.error('data_queque already have the max number');
            return;
        }
        e.dataSize = eventDataSize;
        if (this.get_servetime || this.user_server_time) {
            this.data_queque.push(e);
        }
        else {
            this.temporary_queue.push(e);
        }
        logger('Adding event: ', event);
    };
    Application.prototype.getDataSize = function (data, multiple) {
        if (multiple === void 0) { multiple = 1; }
        var dataJsonSize = JSON.stringify(data).length * multiple;
        return dataJsonSize;
    };
    Application.prototype.compress = function (requset, map) {
        var json = JSON.stringify(requset);
        for (var i in map) {
            json = json.replace(new RegExp("\"" + i + "\":", 'g'), "\"" + map[i] + "\":");
        }
        return JSON.parse(json);
    };
    return Application;
}());
export default Application;
